export default {
  switchAccount: "Cambia Account",
  login: "Accedi",
  loginFirst: "Esegui prima l'accesso",
  start: "Inizia",
  hasHistory: "Hai già risposto ad alcune delle domande.",
  loadHistory: "Vorresti continuare?",
  cancel: "No",
  confirm: "Sì",
  contact:
    "Lascia i tuoi dati di contatto per avere la possibilità di vincere premi bonus!",
  completed: "Hai completato il sondaggio!",
  leaveMessage:
    "Lascia i tuoi dati di contatto per avere la possibilità di vincere premi bonus!",
  enterEmail: "E-mail:",
  enterPhone: "Telefono:",
  submit: "Invia",
  leave: "Abbandona",
  submitted: "Inviato",
  thanks: "Grazie!",
  opinion: "Qual'è la tua opinione?",
  prev: "Precedente",
  next: "Prossimo",
  unlikely: "Molto Improbabile",
  likely: "Molto Probabile",
  claimYourRewards: "Puoi richiedere i tuoi premi.",
  rewardSent: "Ricompense inviate.",
  checkInGame: "Si prega di richiederli nel gioco.",
  copy: "Copia",
  copied: "Copiato!",
  selectTips: "Si prega di selezionare la miglior risposta.",
  multipleTips: "Puoi selezionare più risposte.",
  leastChoose: "Seleziona fino a xxx risposte",
  maxChoose: "Seleziona almeno xxx risposte.",
  mustAnswer: "Si prega di rispondere prima alla domanda attuale.",
  mustWrite: "Per favore scrivi qualcosa.",
  checkEmail: "Si prega di inserire un indirizzo email valido.",
  checkPhone: "Si prega di inserire un numero di telefono valido.",
  isAnswer: "Hai già fatto questo sondaggio.",
  unStart: "Evento non disponibile",
  end: "Evento terminato",
  server: "Seleziona il tuo server",
  role: "Seleziona il tuo personaggio",
  common: "Il sistema è occupato. Riprova più tardi.",
  title: "Questionario",
  titleAward: "Sondaggio",
  leastWord: "Inserisci almeno xxx caratteri.",
  maxWord: "Limite caratteri (xxx) superato!",
  singleChoose: "Risposta Singola",
  multiChoose: "Risposta Multipla",
  matrix: "Risposta Matrix",
  score: "Valutazione",
  textLimit: "(xx-yy caratteri)",
  coverGiftTitle: "Completa Sondaggio per Richiedere Regalo",
  "-20001": "Non connesso",
  "-20002": "Parametri richiesti mancanti",
  "-20003": "Questionario non trovato",
  "-20004": "Configurazione questionario in corso",
  "-20005": "Questionario fermato",
  "-20006": "Evento questionario non iniziato",
  "-20007": "Evento questionario terminato",
  "-20008": "Già risposto",
  "-20010": "Distribuzione ricompensa fallita",
  "-20011": "Ricompensa già distribuita per questo questionario",
  "-20012": "Non ancora risposto",
  "-20016": "ID di gioco non valido",
};
